import { Observable, debounce, interval, map } from 'rxjs';
import { Pub, Service, Sub } from '../service.abstract';

type Actions = 'loading';

interface ILoadingState {
  isLoading: boolean;
  type: LoadingType;
}

export enum LoadingType {
  DEFAULT = 'default',
  LONG = 'long',
}

class PubImpl extends Pub<Actions> {
  loading(newValue: ILoadingState | boolean) {
    if (typeof newValue === 'boolean') {
      this.emit('loading', { isLoading: newValue, type: LoadingType.DEFAULT });
    } else {
      this.emit('loading', newValue);
    }
  }
}

class SubImpl extends Sub<Actions> {
  loading(): Observable<ILoadingState> {
    return this.actionListener('loading').pipe(
      map(({ params }) => params),
      debounce((state) => (state.isLoading ? interval(0) : interval(300))),
    );
  }

  longLoading(): Observable<boolean> {
    return this.loading().pipe(map((state) => state.isLoading && state.type === LoadingType.LONG));
  }
}

export class LoadingService extends Service<Actions> {
  pub = new PubImpl(this.stream$);
  sub = new SubImpl(this.stream$);

  setLoading(isLoading: boolean, type: LoadingType = LoadingType.DEFAULT) {
    this.pub.loading({ isLoading, type });
  }
}
